import React from 'react';
import { cn } from './cn';

const Input = React.forwardRef(({ className, type = 'text', ...props }, ref) => (
  <input
    type={type}
    className={cn(
      'flex h-10 w-full rounded-md border border-succession-border bg-succession-bg-primary px-3 py-2 text-sm text-succession-text-primary placeholder:text-succession-text-secondary focus:outline-none focus:ring-2 focus:ring-succession-primary focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50 transition-colors duration-300',
      className
    )}
    ref={ref}
    {...props}
  />
));

Input.displayName = 'Input';

export { Input };
